/* Tienda VivaCore · utilidades compartidas
 * - [data-vc-order]: abre el formulario de Releasit (pago contra entrega).
 * - [data-vc-sticky]: barra fija que aparece al hacer scroll.
 * - [data-vc-eta]: fecha estimada de entrega (días hábiles).
 */
(function () {
  // Botón real de Releasit (no el flotante). Releasit usa el id "rsi_buy_now_button".
  var RELEASIT_SELECTORS = [
    'button#rsi_buy_now_button:not(.rsi_floating)',
    '._rsi-buy-now-button-app-block-hook button',
    'button#rsi_buy_now_button',
    'button._rsi-buy-now-button',
    '[data-releasit-button]'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function openOrder(trigger) {
    var pos = trigger.getAttribute('data-vc-select');
    if (pos) {
      var kit = document.querySelector('[data-vc-kit][data-pos="' + pos + '"]');
      if (kit && !kit.checked) {
        kit.checked = true;
        kit.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var formId = trigger.getAttribute('data-vc-order');
    var form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
    var releasit = findReleasitButton();
    if (releasit) {
      releasit.click();
      return;
    }
    // Sin Releasit: enviar el formulario del producto (agrega al carrito) o ir al formulario principal.
    if (form) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
      return;
    }
    var main = document.querySelector('product-form-component, .product-form, form[action*="/cart/add"]');
    if (main) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-vc-order]');
    if (!t) return;
    e.preventDefault();
    openOrder(t);
  });

  // Selección de kit: actualiza la variante del formulario.
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-vc-kit]');
    if (!input) return;
    var form = document.getElementById(input.getAttribute('data-vc-form'));
    if (!form) return;
    var idField = form.querySelector('input[name="id"]');
    if (idField) {
      idField.value = input.value;
      idField.dispatchEvent(new Event('change', { bubbles: true }));
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    } catch (err) {}
    document.querySelectorAll('[data-vc-kit-price]').forEach(function (el) {
      el.textContent = input.getAttribute('data-price');
    });
    document.querySelectorAll('[data-vc-kit-label]').forEach(function (el) {
      el.textContent = input.getAttribute('data-label');
    });
    var group = input.closest('[data-vc-kits]');
    if (group) {
      group.querySelectorAll('.al-kit').forEach(function (k) { k.classList.remove('is-on'); });
      input.closest('.al-kit').classList.add('is-on');
    }
  });

  function initSticky() {
    document.querySelectorAll('[data-vc-sticky]').forEach(function (bar) {
      var anchor = document.querySelector(bar.getAttribute('data-vc-sticky')) || document.body;
      if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(anchor);
    });
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }

  function initEta() {
    document.querySelectorAll('[data-vc-eta]').forEach(function (el) {
      var parts = (el.getAttribute('data-vc-eta') || '1-3').split('-');
      var lang = document.documentElement.lang || 'es';
      var fmt = { weekday: 'short', day: 'numeric', month: 'short' };
      var from = addBusinessDays(new Date(), parseInt(parts[0], 10) || 1);
      var to = addBusinessDays(new Date(), parseInt(parts[1] || parts[0], 10) || 3);
      try {
        el.textContent = from.toLocaleDateString(lang, fmt) + ' – ' + to.toLocaleDateString(lang, fmt);
      } catch (err) {}
    });
  }

  // Barra fija: mostrar desde el inicio el precio del kit seleccionado (no el de la primera variante).
  function syncKitPrice() {
    var kit = document.querySelector('[data-vc-kit]:checked');
    if (!kit) return;
    document.querySelectorAll('[data-vc-kit-price]').forEach(function (el) { el.textContent = kit.getAttribute('data-price'); });
    document.querySelectorAll('[data-vc-kit-label]').forEach(function (el) { el.textContent = kit.getAttribute('data-label'); });
  }


  // Reseñas: mueve el widget de BK Reviews a la sección "AL · Testimonios" (si existe en la página).
  function moveReviewsWidget() {
    var slot = document.querySelector('[data-vc-reviews-slot]');
    if (!slot || slot.children.length) return !!(slot && slot.children.length);
    var nodes = document.querySelectorAll('[id*="bk-"], [class*="bk-"], [id*="bk_"], [class*="bk_"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.id === 'bk-reviews-root' || slot.contains(el) || el.closest('[data-vc-reviews-slot]')) continue;
      var txt = el.textContent || '';
      if (!/rese(ñ|n)a/i.test(txt) || el.getBoundingClientRect().height < 120) continue;
      // sube hasta el contenedor del widget, sin salir de la sección donde fue insertado
      while (el.parentElement && !el.parentElement.matches('.shopify-section, main, body, .al-info, .al-hero__grid, .vc-wrap, .vc-narrow') && /rese(ñ|n)a/i.test(el.parentElement.textContent || '') && el.parentElement.getBoundingClientRect().height < el.getBoundingClientRect().height * 1.6) {
        el = el.parentElement;
      }
      // Sin reseñas ("0 reseñas"): ocultar el widget en lugar de mostrarlo vacío
      if (/(^|\D)0\s*rese(ñ|n)as?/i.test(el.textContent || '')) {
        el.style.display = 'none';
        return true;
      }
      slot.appendChild(el);
      var sec = slot.closest('.al-rev'); if (sec) sec.classList.remove('al-rev--empty');
      return true;
    }
    return false;
  }
  function watchReviews() {
    if (!document.querySelector('[data-vc-reviews-slot]')) return;
    if (moveReviewsWidget()) return;
    var mo = new MutationObserver(function () { if (moveReviewsWidget()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  function init() { initSticky(); initEta(); syncKitPrice(); watchReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
